import { customAttribute } from '@core-ui/reporting';
import { storageHelper } from '@core-ui/utility';
import { setManualScrollRestoration } from '../../helpers/manual-scroll-restoration';
import { SCROLLED_CID, SCROLL_Y_POSITION } from '../../utils/constants';
import { reportExceptionToNewRelic } from '../../helpers/report-exception-to-new-relic';
import { scrollY } from '../../helpers/scroll-y';

enum Attribute {
  CatAutoscroll = 'catAutoscroll',
  CatAutoscrollPosition = 'catAutoscrollPosition',
  CatAutoscrollCid = 'catAutoscrollCid'
}

let storage: Storage;

if (typeof window !== 'undefined') {
  storage = storageHelper(sessionStorage);
}

const setAutoscrollAttributes = (scrollReportingEnabled = false) => {
  if (scrollReportingEnabled) {
    customAttribute(Attribute.CatAutoscroll, 'FAIL');

    customAttribute(
      Attribute.CatAutoscrollPosition,
      window.sessionStorage.getItem(SCROLL_Y_POSITION)
    );

    customAttribute(
      Attribute.CatAutoscrollCid,
      window.sessionStorage.getItem(SCROLLED_CID)
    );
  }
};

const scrollToPosition = (
  scrollYPosition: number,
  scrollReportingEnabled: boolean
) => {
  const scroll = (): void => {
    requestAnimationFrame(() => {
      scrollY(scrollYPosition);
    });
  };
  return scroll;
};

const removePropertiesFromSessionStorage = () => {
  storage?.removeItem(SCROLL_Y_POSITION);
  storage?.removeItem(SCROLLED_CID);
};

export const scrollToPreviousPosition = (
  scrollReportingEnabled = false
): void => {
  try {
    setManualScrollRestoration();
    setAutoscrollAttributes(scrollReportingEnabled);

    const scrollSetByPreviousPdpClick = storage?.getItem(SCROLL_Y_POSITION);

    if (scrollSetByPreviousPdpClick) {
      const scroll = scrollToPosition(
        Number(scrollSetByPreviousPdpClick),
        scrollReportingEnabled
      );
      window.requestAnimationFrame(() => {
        Promise.resolve()
          .then(scroll)
          .then(() => {
            if (scrollReportingEnabled) {
              customAttribute('catAutoscroll', 'SUCCESS');
            }
          })
          .catch(error => {
            /* istanbul ignore next */
            if (scrollReportingEnabled) {
              reportExceptionToNewRelic(
                'scrollToPreviousPosition | Promise',
                error
              );
            }
          });
      });
      removePropertiesFromSessionStorage();
    }
  } catch (error) {
    reportExceptionToNewRelic(
      'scrollToPreviousPosition',
      error,
      scrollReportingEnabled
    );
  }
};

export const shouldScrollToPreviousPosition = (cid: string): boolean =>
  storage?.getItem(SCROLLED_CID) === cid;
